<template>
  <span style="white-space: pre-wrap;"><slot></slot></span>
</template>

<script>

export default {

  data () {
    return {
    }
  }

}
</script>
